<template>
  <div class="">
     <!-- 查询表单 -->
     <div>
      <el-form ref="functionQuestionConfigForm" :model="functionQuestionConfigForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                v-model="functionQuestionConfigForm.categoryId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getFunctionQuestionConfigList">查询</el-button>
            <el-button type="primary" @click="addFunctionQuestionConfig">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="optionNameStr"
            show-overflow-tooltip
            label="选项名称">
          </el-table-column>
          <el-table-column
            prop="optionValueNameStr"
            show-overflow-tooltip
            label="选项值名称">
          </el-table-column>
          <el-table-column
            prop="limitGradeName"
            label="等级">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === '0'">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorFunctionQuestionConfig(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === '1'">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteSearchFunctionQuestionConfig(scope.row)" type="text" size="small">删除</el-button> 
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '更新功能问题' : '添加功能问题'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editFunctionQuestionConfigForm" :model="editFunctionQuestionConfigForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editFunctionQuestionConfigForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="分类">
              <el-select
                v-model="editFunctionQuestionConfigForm.categoryId"
                clearable
                placeholder="请选择"
                @change="changeOtherOptions()"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="评估项目"
              prop="itemIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectItem(itemIdList)"
                  >
                    <el-option
                      v-for="item in functionConditionValues"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>
            <el-form-item
              label="选项"
              prop="itemValueIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemValueIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in itemValueOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>
            <el-form-item label="等级" prop="limitGradeId">
              <el-select
                clearable
                v-model="editFunctionQuestionConfigForm.limitGradeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in editGradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      functionQuestionConfigForm: {
        openName: null
      },
      valuationClass:26,

      itemValueIdList:[],
      
    //评估项目和值
    functionConditionValues: [],
    itemValueOptions: [],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:null,

      // 新建编辑对话框数据

      isDlg: false,
      editFunctionQuestionConfigForm: {
        id: null,
        categoryName:null,
        brandName:null,
        modeId:null,
        modelName:null,
        hjxCategoryId:null,
        hjxBrandId:null,
        hjxModelId:null
      },
      dlgType: 'change',
      queryGradeList:[],
        // 选择
      modelOptions: [],
      loading: false,
      updateFlag:false,
      editGradeList:[],

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      skuInfo:{},
      selectOptionValueList:[],
      valuationOptionList:[],
      itemIdList:[],
      editorFormRules: {
        hjxAttrId: [
          { required: true, message: '请选择选项值', trigger: 'change' },
        ]
      },
    }
  },
  watch:{},
  computed:{},
  methods:{
     // 开启门店
     open(id) {
      let self = this
      this.$api.openFunctionQuestionConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getFunctionQuestionConfigList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeFunctionQuestionConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getFunctionQuestionConfigList()
        }
      })
    },
     //改变分类，品牌和等级集合发生变化
    changeOtherOptions() {
      let self = this;
      self.getEavlItemOptions();
      self.getGradeList();
      this.$nextTick(()=>{
          self.$set(self.editFunctionQuestionConfigForm, "limitGradeId", null);
          self.$set(self, "itemIdList", []);
          self.$set(self, "itemValueIdList", []);
      })
    },
    // 获取评估项目选项和值
    getEavlItemOptions() {
      if (this.editFunctionQuestionConfigForm.categoryId === "") {
        this.functionConditionValues = []
        this.itemValueOptions=[]
        return;
      }
      let self = this;
      self.$api
        .getEvaluationOptions({
          categoryId: self.editFunctionQuestionConfigForm.categoryId,
          brandId: null,
          typeKey:
            "evaluate_function,evaluate_value,category",
        })
        .then((res) => {
          if (res.code === 200) {
            self.functionConditionValues = res.data;
            this.getSelectItem(this.itemIdList)
          }
        });
    },
        //选中评估项，更新评估项选项值
    getSelectItem(values) {
      let self = this;
      self.$set(self, "itemIdList", values);
      this.itemValueOptions=[]
      for (let index = 0;  index < this.functionConditionValues.length; index++) {
        let item = this.functionConditionValues[index];
        if(values.includes(item.id)){
          this.itemValueOptions = this.itemValueOptions.concat(item.children);
        }

      }
    },
    //等级
   getGradeList() {
      let self = this;
      let categoryId = this.editFunctionQuestionConfigForm.categoryId;
      if (categoryId === "") {
        this.editGradeList = []
        return;
      }
        this.$api
          .getValidModelGrade({
            categoryId: categoryId,
          })
          .then((res) => {
            self.editGradeList = res.data || [];
          });
    },
    deleteSearchFunctionQuestionConfig(row){
      let self = this
      self.$api.deleteSearchFunctionQuestionConfig({id:row.id}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getFunctionQuestionConfigList()
              }
            })
    },
    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },
    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getValuationOptionList(categoryId,LinkageTypeId) {
      let self = this;
      self.$api
        .getValuationOptionList({
          categoryId: categoryId,
          linkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.valuationOptionList = res.data;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectFuncationAndConditionOptionValueList(optionId) {
      let self = this;
      self.$api
        .getSelectFuncationAndConditionOptionValueList({
          optionId: optionId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
     // 请求分类列表，提供编辑时选择用
     getSelectOptionValueList(categoryId, brandId,LinkageTypeId) {
      let self = this;
      self.$api
        .getSelectOptionValueList({
          categoryId: categoryId,
          brandId: brandId,
          LinkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getFunctionQuestionConfigList()
    }, 

    // 获取门店列表
    getFunctionQuestionConfigList() {
      let self  = this;
      self.$api.listSearchFunctionQuestionConfig({
        page: self.currentPage,
        size: self.pageSize,
        categoryId: self.functionQuestionConfigForm.categoryId || null,
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 修改门店
    editorFunctionQuestionConfig(row) {
      let self = this;
      self.editFunctionQuestionConfigForm=JSON.parse(JSON.stringify(row));
      this.itemIdList=JSON.parse(self.editFunctionQuestionConfigForm.optionIdList)
      this.itemValueIdList=JSON.parse(self.editFunctionQuestionConfigForm.optionValueIdList)
      self.dlgType = 'change'
      self.getEavlItemOptions();
      self.getGradeList();
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },
    // 添加门店
    addFunctionQuestionConfig() {
      let self=this
      this.dlgType = 'new'
      this.editFunctionQuestionConfigForm =  {
        id: null,
        categoryId:null,
        optionIdList: null,
        optionValueIdList: null,
      }
      this.itemIdList=[]
      this.itemValueIdList = []
      this.$nextTick(()=>{
          this.$refs['editFunctionQuestionConfigForm'].clearValidate()
      })
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editFunctionQuestionConfigForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            let optionIdListStr = JSON.stringify(self.itemIdList)
            let optionValueIdListStr = JSON.stringify(self.itemValueIdList)
            self.$api.updateFunctionQuestionConfig({id:self.editFunctionQuestionConfigForm.id,categoryId:self.editFunctionQuestionConfigForm.categoryId,
              optionIdList:optionIdListStr,optionValueIdList:optionValueIdListStr,
              limitGradeId:self.editFunctionQuestionConfigForm.limitGradeId
            }).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getFunctionQuestionConfigList()
                this.closeEditorDlg()
              }
            })
          }else{
            let optionIdListStr = JSON.stringify(self.itemIdList)
            let optionValueIdListStr = JSON.stringify(self.itemValueIdList)
            self.$api.saveSearchFunctionQuestionConfig({categoryId:self.editFunctionQuestionConfigForm.categoryId,
              optionIdList:optionIdListStr,optionValueIdList:optionValueIdListStr,
              limitGradeId:self.editFunctionQuestionConfigForm.limitGradeId}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getFunctionQuestionConfigList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },


  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getFunctionQuestionConfigList();
    self.getSelectOptions("category", "categoryOptions");
  }
}
</script>
<style lang="less" scoped>
 
    /deep/ .el-radio__original {
      display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
    }
    
    /deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>